export const environment = {
    production: true,
    apiBaseUrl: 'https://financial-omnik.fcamara.com.br/api',
    frontBaseUrl: 'https://financial-omnik.fcamara.com.br',
    FILE_MANAGER_URL: "https://3s61zqbfy2.execute-api.us-east-1.amazonaws.com/prod",
    microsoftGraphApi: 'https://graph.microsoft.com/v1.0'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts